import React from "react";
import LinkedEntityCollapseList from "@common/components/linkedEntityCollapseList/LinkedEntityCollapseList.tsx";
import { useTranslation } from "@localization/useTranslation.ts";
import { useProcessProcessingActivitiesField } from "./ProcessProcessingActivitiesField.hooks.ts";

export interface ProcessProcessingActivitiesFieldProps {
    processingActivityIds: Array<string>;
    onChange: (processingActivityIds: Array<string>) => void;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function ProcessProcessingActivitiesField(props: ProcessProcessingActivitiesFieldProps) {
    const { translateString } = useTranslation();
    const { isLoading, data, getLinkTo } = useProcessProcessingActivitiesField(props);

    return (
        <LinkedEntityCollapseList
            header={translateString("processProcessingActivitiesHeader")}
            selectedIds={props.processingActivityIds}
            selectableItems={data}
            onChange={props.onChange}
            getLinkTo={getLinkTo}
            addButtonText={translateString("addProcessingActivity")}
            removeItemText={translateString("removeProcessingActivity")}
            selectLabel={translateString("processingActivity")}
            disabled={props.disabled}
            isLoading={isLoading}
            isPreview={props.isPreview}
            errorText={props.errorText}
        />
    );
}

export default ProcessProcessingActivitiesField;
